import { render } from "./videoDisplay.vue?vue&type=template&id=8e213cda"
import script from "./videoDisplay.vue?vue&type=script&lang=js"
export * from "./videoDisplay.vue?vue&type=script&lang=js"

import "./videoDisplay.vue?vue&type=style&index=0&id=8e213cda&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__